import React, { useState } from "react";
import Layout from "../components/layouts/Layout";

const ResourceCenterPage = () => {
  const [activeTab, setActiveTab] = useState('whitepapers');
  const [gateForm, setGateForm] = useState({
    name: '',
    email: '',
    company: '',
    position: ''
  });
  const [showGate, setShowGate] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);

  const whitepapers = [
    {
      id: 1,
      title: "量子機械学習の産業応用: 2024年版完全ガイド",
      description: "量子コンピューティングとAIの融合による次世代ソリューション",
      pages: 45,
      downloadCount: 2580,
      category: "量子AI",
      level: "上級",
      publishDate: "2024年3月",
      thumbnail: "Data",
      highlights: [
        "量子機械学習の基礎理論",
        "産業別実装ガイド",
        "ROI最大化戦略",
        "2024年最新トレンド"
      ],
      gated: true
    },
    {
      id: 2,
      title: "デジタル変革のためのAI導入戦略",
      description: "企業のDXを加速するAI活用の実践的アプローチ",
      pages: 38,
      downloadCount: 4200,
      category: "DX戦略",
      level: "中級",
      publishDate: "2024年2月",
      thumbnail: "🚀",
      highlights: [
        "DX成功の7つの要因",
        "AI導入ロードマップ",
        "組織変革のポイント",
        "投資回収計算方法"
      ],
      gated: true
    },
    {
      id: 3,
      title: "AI時代のデータガバナンス",
      description: "データ品質管理とセキュリティの最新ベストプラクティス",
      pages: 32,
      downloadCount: 1890,
      category: "データ管理",
      level: "中級",
      publishDate: "2024年1月",
      thumbnail: "🔒",
      highlights: [
        "データガバナンス フレームワーク",
        "プライバシー保護技術",
        "コンプライアンス対応",
        "セキュリティ監査"
      ],
      gated: true
    }
  ];

  const technicalDocs = [
    {
      id: 1,
      title: "DeepTeLL API リファレンス v3.2",
      description: "AIプラットフォーム統合のための完全技術仕様",
      type: "API仕様",
      version: "3.2",
      lastUpdated: "2024年4月15日",
      thumbnail: "📚",
      size: "2.4MB",
      gated: false
    },
    {
      id: 2,
      title: "機械学習モデル最適化ガイド",
      description: "パフォーマンスとコスト効率を両立する実装手法",
      type: "実装ガイド",
      version: "2.1",
      lastUpdated: "2024年4月10日",
      thumbnail: "⚙️",
      size: "1.8MB",
      gated: false
    },
    {
      id: 3,
      title: "セキュリティ構成ベストプラクティス",
      description: "エンタープライズ環境でのセキュア導入指針",
      type: "セキュリティ",
      version: "1.5",
      lastUpdated: "2024年4月5日",
      thumbnail: "🛡️",
      size: "3.1MB",
      gated: false
    }
  ];

  const webinars = [
    {
      id: 1,
      title: "量子AI革命: 2024年の最新動向と未来展望",
      description: "業界のトップエキスパートが語る量子機械学習の最前線",
      date: "2024年5月15日",
      time: "14:00-15:30 JST",
      speaker: "田中智彦（CEO）, 佐藤美咲（CTO）",
      attendees: 0,
      maxAttendees: 500,
      status: "upcoming",
      thumbnail: "🎯",
      agenda: [
        "量子AI技術の現状と課題",
        "実用化に向けたブレークスルー",
        "産業応用の成功事例",
        "Q&Aセッション"
      ]
    },
    {
      id: 2,
      title: "製造業DXとAI活用の実践事例",
      description: "スマートファクトリー実現のための具体的手法",
      date: "2024年5月8日",
      time: "16:00-17:00 JST",
      speaker: "製造業AI専門チーム",
      attendees: 245,
      maxAttendees: 300,
      status: "ongoing",
      thumbnail: "🏭",
      agenda: [
        "製造業AI導入のポイント",
        "予知保全システムの構築",
        "品質管理の自動化",
        "ROI最大化の秘訣"
      ]
    },
    {
      id: 3,
      title: "金融AI: リスク管理の新時代",
      description: "最新のリスク評価技術と規制対応",
      date: "2024年4月20日",
      time: "13:00-14:30 JST",
      speaker: "金融AI研究チーム",
      attendees: 428,
      maxAttendees: 400,
      status: "completed",
      thumbnail: "💰",
      agenda: [
        "最新リスク評価手法",
        "AI監査とコンプライアンス",
        "実装時の注意点",
        "成功事例の紹介"
      ]
    }
  ];

  const handleGatedDownload = (resource) => {
    setSelectedResource(resource);
    setShowGate(true);
  };

  const handleGateSubmit = (e) => {
    e.preventDefault();
    // ゲートフォーム送信処理
    console.log('Gate form submitted:', gateForm);
    
    // PDFダウンロード処理
    const link = document.createElement('a');
    link.href = `/pdf/${selectedResource.title.replace(/\s+/g, '_')}.pdf`;
    link.download = `${selectedResource.title}.pdf`;
    link.click();
    
    setShowGate(false);
    setGateForm({ name: '', email: '', company: '', position: '' });
    alert(`${selectedResource.title}をダウンロードしました！`);
  };

  const handleWebinarRegistration = (webinar) => {
    alert(`「${webinar.title}」への参加申し込みを受け付けました！`);
  };

  return (
    <Layout 
      title="リソースセンター" 
      subtitle="AI技術とビジネス戦略に関する豊富な学習コンテンツをご提供"
    >
      {/* タブナビゲーション */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <div style={{ display: 'inline-flex', background: 'rgba(30, 41, 59, 0.8)', borderRadius: '8px', padding: '4px' }}>
                  <button
                    className={`btn ${activeTab === 'whitepapers' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('whitepapers')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'whitepapers' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'whitepapers' ? 'white' : '#cbd5e1'
                    }}
                  >
                    📄 ホワイトペーパー
                  </button>
                  <button
                    className={`btn ${activeTab === 'technical' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('technical')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'technical' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'technical' ? 'white' : '#cbd5e1'
                    }}
                  >
                    📚 技術資料
                  </button>
                  <button
                    className={`btn ${activeTab === 'webinars' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('webinars')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'webinars' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'webinars' ? 'white' : '#cbd5e1'
                    }}
                  >
                    🎥 ウェビナー
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ホワイトペーパー */}
      {activeTab === 'whitepapers' && (
        <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                  <h2 style={{ color: '#3b82f6', marginBottom: '15px' }}>📄 ホワイトペーパー</h2>
                  <p style={{ color: '#cbd5e1' }}>業界のインサイトと最新トレンドを深く掘り下げた専門資料</p>
                </div>
              </div>
            </div>
            <div className="row">
              {whitepapers.map((paper) => (
                <div key={paper.id} className="col-md-4" style={{ marginBottom: '40px' }}>
                  <div className="premium-card" style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                      <div style={{ fontSize: '48px' }}>{paper.thumbnail}</div>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <span style={{ 
                          background: '#1e40af', 
                          color: 'white', 
                          padding: '4px 8px', 
                          borderRadius: '12px',
                          fontSize: '11px'
                        }}>
                          {paper.category}
                        </span>
                        <span style={{ 
                          background: paper.level === '上級' ? '#dc2626' : '#f59e0b', 
                          color: 'white', 
                          padding: '4px 8px', 
                          borderRadius: '12px',
                          fontSize: '11px'
                        }}>
                          {paper.level}
                        </span>
                      </div>
                    </div>

                    <h3 style={{ color: '#f1f5f9', marginBottom: '15px', fontSize: '18px' }}>
                      {paper.title}
                    </h3>

                    <p style={{ color: '#94a3b8', marginBottom: '20px', fontSize: '14px' }}>
                      {paper.description}
                    </p>

                    <div style={{ marginBottom: '20px' }}>
                      <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>主要内容:</h5>
                      <ul style={{ color: '#94a3b8', marginLeft: '0', listStyle: 'none' }}>
                        {paper.highlights.map((highlight, index) => (
                          <li key={index} style={{ marginBottom: '5px' }}>✓ {highlight}</li>
                        ))}
                      </ul>
                    </div>

                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      background: 'rgba(59, 130, 246, 0.1)',
                      padding: '10px',
                      borderRadius: '8px',
                      marginBottom: '20px'
                    }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ color: '#3b82f6', fontWeight: 'bold' }}>{paper.pages}</div>
                        <div style={{ color: '#94a3b8', fontSize: '12px' }}>ページ</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ color: '#3b82f6', fontWeight: 'bold' }}>{paper.downloadCount.toLocaleString()}</div>
                        <div style={{ color: '#94a3b8', fontSize: '12px' }}>ダウンロード</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ color: '#3b82f6', fontWeight: 'bold' }}>{paper.publishDate}</div>
                        <div style={{ color: '#94a3b8', fontSize: '12px' }}>公開</div>
                      </div>
                    </div>

                    <button 
                      className="btn btn-custom"
                      onClick={() => handleGatedDownload(paper)}
                      style={{ width: '100%' }}
                    >
                      🔒 ダウンロード（要登録）
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* 技術資料 */}
      {activeTab === 'technical' && (
        <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                  <h2 style={{ color: '#3b82f6', marginBottom: '15px' }}>📚 技術資料</h2>
                  <p style={{ color: '#cbd5e1' }}>開発者向けの技術仕様書と実装ガイド</p>
                </div>
              </div>
            </div>
            <div className="row">
              {technicalDocs.map((doc) => (
                <div key={doc.id} className="col-md-4" style={{ marginBottom: '30px' }}>
                  <div className="premium-card" style={{ 
                    padding: '25px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ fontSize: '36px', marginRight: '15px' }}>{doc.thumbnail}</div>
                      <div>
                        <span style={{ 
                          background: '#059669', 
                          color: 'white', 
                          padding: '2px 8px', 
                          borderRadius: '12px',
                          fontSize: '11px'
                        }}>
                          {doc.type}
                        </span>
                      </div>
                    </div>

                    <h4 style={{ color: '#f1f5f9', marginBottom: '10px', fontSize: '16px' }}>
                      {doc.title}
                    </h4>

                    <p style={{ color: '#94a3b8', marginBottom: '15px', fontSize: '13px' }}>
                      {doc.description}
                    </p>

                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      color: '#94a3b8',
                      fontSize: '12px',
                      marginBottom: '15px'
                    }}>
                      <span>v{doc.version}</span>
                      <span>{doc.size}</span>
                      <span>{doc.lastUpdated}</span>
                    </div>

                    <button 
                      className="btn btn-outline-custom btn-sm"
                      onClick={() => {
                        const link = document.createElement('a');
                        link.href = `/pdf/${doc.title.replace(/\s+/g, '_')}.pdf`;
                        link.download = `${doc.title}.pdf`;
                        link.click();
                      }}
                      style={{ width: '100%' }}
                    >
                      📥 ダウンロード
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ウェビナー */}
      {activeTab === 'webinars' && (
        <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                  <h2 style={{ color: '#3b82f6', marginBottom: '15px' }}>🎥 ウェビナー</h2>
                  <p style={{ color: '#cbd5e1' }}>専門家による最新技術動向とビジネス戦略セミナー</p>
                </div>
              </div>
            </div>
            <div className="row">
              {webinars.map((webinar) => (
                <div key={webinar.id} className="col-md-6" style={{ marginBottom: '30px' }}>
                  <div className="premium-card" style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                      <div style={{ fontSize: '48px' }}>{webinar.thumbnail}</div>
                      <span style={{ 
                        background: webinar.status === 'upcoming' ? '#059669' : 
                                  webinar.status === 'ongoing' ? '#f59e0b' : '#6b7280',
                        color: 'white', 
                        padding: '4px 12px', 
                        borderRadius: '20px',
                        fontSize: '12px'
                      }}>
                        {webinar.status === 'upcoming' ? '開催予定' : 
                         webinar.status === 'ongoing' ? '開催中' : '終了'}
                      </span>
                    </div>

                    <h3 style={{ color: '#f1f5f9', marginBottom: '15px', fontSize: '18px' }}>
                      {webinar.title}
                    </h3>

                    <p style={{ color: '#94a3b8', marginBottom: '20px', fontSize: '14px' }}>
                      {webinar.description}
                    </p>

                    <div style={{ 
                      background: 'rgba(59, 130, 246, 0.1)',
                      padding: '15px',
                      borderRadius: '8px',
                      marginBottom: '20px'
                    }}>
                      <div style={{ color: '#3b82f6', fontWeight: 'bold', marginBottom: '8px' }}>
                        {webinar.date} | {webinar.time}
                      </div>
                      <div style={{ color: '#cbd5e1', fontSize: '14px', marginBottom: '8px' }}>
                        👨‍🏫 講師: {webinar.speaker}
                      </div>
                      <div style={{ color: '#94a3b8', fontSize: '13px' }}>
                        👥 参加者: {webinar.attendees}/{webinar.maxAttendees}名
                      </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>アジェンダ:</h5>
                      <ul style={{ color: '#94a3b8', marginLeft: '0', listStyle: 'none' }}>
                        {webinar.agenda.map((item, index) => (
                          <li key={index} style={{ marginBottom: '5px' }}>• {item}</li>
                        ))}
                      </ul>
                    </div>

                    {webinar.status === 'upcoming' && (
                      <button 
                        className="btn btn-custom"
                        onClick={() => handleWebinarRegistration(webinar)}
                        style={{ width: '100%' }}
                      >
                        📝 参加申し込み
                      </button>
                    )}

                    {webinar.status === 'ongoing' && (
                      <button 
                        className="btn btn-success"
                        style={{ width: '100%' }}
                      >
                        ライブ参加
                      </button>
                    )}

                    {webinar.status === 'completed' && (
                      <button 
                        className="btn btn-outline-custom"
                        style={{ width: '100%' }}
                      >
                        📺 録画視聴
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ゲートフォーム（モーダル） */}
      {showGate && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#1e293b',
            padding: '40px',
            borderRadius: '12px',
            border: '1px solid rgba(59, 130, 246, 0.2)',
            maxWidth: '500px',
            width: '90%'
          }}>
            <h3 style={{ color: '#3b82f6', marginBottom: '20px' }}>
              📄 {selectedResource?.title}
            </h3>
            <p style={{ color: '#cbd5e1', marginBottom: '30px' }}>
              ダウンロードには簡単な情報入力が必要です。
            </p>

            <form onSubmit={handleGateSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                  お名前 *
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={gateForm.name}
                  onChange={(e) => setGateForm({...gateForm, name: e.target.value})}
                  required
                  style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid #475569',
                    color: '#e2e8f0'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                  メールアドレス *
                </label>
                <input
                  type="email"
                  className="form-control"
                  value={gateForm.email}
                  onChange={(e) => setGateForm({...gateForm, email: e.target.value})}
                  required
                  style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid #475569',
                    color: '#e2e8f0'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                  会社名
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={gateForm.company}
                  onChange={(e) => setGateForm({...gateForm, company: e.target.value})}
                  style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid #475569',
                    color: '#e2e8f0'
                  }}
                />
              </div>

              <div style={{ marginBottom: '30px' }}>
                <label style={{ color: '#f1f5f9', marginBottom: '8px', display: 'block' }}>
                  役職
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={gateForm.position}
                  onChange={(e) => setGateForm({...gateForm, position: e.target.value})}
                  style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid #475569',
                    color: '#e2e8f0'
                  }}
                />
              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
                <button 
                  type="submit" 
                  className="btn btn-custom"
                  style={{ flex: 1 }}
                >
                  📥 ダウンロード
                </button>
                <button 
                  type="button" 
                  className="btn btn-outline-custom"
                  onClick={() => setShowGate(false)}
                  style={{ flex: 1 }}
                >
                  キャンセル
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* CTA セクション */}
      <section style={{ 
        padding: '80px 0', 
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                さらに詳しい情報が必要ですか？
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                専門コンサルタントがあなたのニーズに合わせたカスタム資料をご提供いたします。
              </p>
              <a href="/contact" className="btn btn-custom btn-lg" style={{ 
                background: 'rgba(255, 255, 255, 0.2)',
                border: '2px solid white',
                color: 'white'
              }}>
                💬 専門相談を申し込む
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ResourceCenterPage; 